import Proj1 from "../assets/proj1.png";
import Proj2 from "../assets/proj2.png";
import Proj3 from "../assets/proj3.png";

export const ProjectList = [
  {
    name: "Chat App",
    image: Proj1,
    skills: "React-Js, Material UI, Firebase, React-Router",
  },
  {
    name: "Netflix UI",
    image: Proj2,
    skills: "React-Js, TMDB-API, Firebase, React-Router, Google Authentication",
  },
  {
    name: "Spotify Clone",
    image: Proj3,
    skills: "React-Js, Spotify-API, Node, Express",
  },
];
